/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_DisclaimerInputs */

const en_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disclaimer: Crazy Frog AI is an independent AI video and image generation service and is not affiliated with, endorsed by, or sponsored by any AI model provider or other third-party brand referenced on this site, including ByteDance, Seedance, Kling, Wan, xAI, and Google. AI-generated videos and images may contain errors, artifacts, or inaccuracies. You are solely responsible for the content you upload and create. Use of this service is at your own risk. Nothing on this site constitutes legal, financial, or professional advice.`)
};

const es_footer_disclaimer = /** @type {(inputs: Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso: Crazy Frog AI es un servicio independiente de generación de videos e imágenes con IA y no está afiliado, respaldado ni patrocinado por ningún proveedor de modelos de IA u otra marca de terceros mencionada en este sitio, incluidos ByteDance, Seedance, Kling, Wan, xAI y Google. Los videos e imágenes generados por IA pueden contener errores, artefactos o imprecisiones. Eres el único responsable del contenido que subes y creas. Usa el servicio bajo tu propio riesgo. Nada en este sitio constituye asesoramiento legal, financiero o profesional.`)
};

/**
* | output |
* | --- |
* | "Disclaimer: Crazy Frog AI is an independent AI video and image generation service and is not affiliated with, endorsed by, or sponsored by any AI model provi..." |
*
* @param {Footer_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const footer_disclaimer = /** @type {((inputs?: Footer_DisclaimerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_DisclaimerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_disclaimer(inputs)
	return es_footer_disclaimer(inputs)
});